import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BundleLineInEnvProvider } from './bundle-line-in.env.provider';
import {
  TREQUEST_SAVE_EVENT_BUNDLE_LINE_IN,
  TREQUEST_BUNDLE_LINE_IN_ACTIVITY_LOG,
  TREQUEST_BUNDLE_LINE_IN_TRANSACTION_LOG,
  TREQUEST_GET_BUNDLE_LINE_IN_TAG,
  TREQUEST_RESTORE_COUNT_BUNDLE_LINE_IN,
  TREQUEST_BUNDLE_LINE_IN_AVAILABLE_WIP,
  TRESPONSE_SAVE_EVENT_BUNDLE_LINE_IN,
  TRESPONSE_BUNDLE_LINE_IN_ACTIVITY_LOG,
  TRESPONSE_BUNDLE_LINE_IN_TRANSACTION_LOG,
  TRESPONSE_GET_BUNDLE_LINE_IN_TAG,
  TRESPONSE_RESTORE_COUNT_BUNDLE_LINE_IN,
  TRESPONSE_BUNDLE_LINE_IN_AVAILABLE_WIP,
} from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class BundleLineInDataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private bundleLineInEnvProvider: BundleLineInEnvProvider) {}

  getBundleLineInTagDetails(payload: TREQUEST_GET_BUNDLE_LINE_IN_TAG) {
    const URL = this.bundleLineInEnvProvider.getEnvVar('GET_BUNDLE_LINE_IN_TAG');
    return this.http.post<TRESPONSE_GET_BUNDLE_LINE_IN_TAG>(URL, payload);
  }

  fetchBundleLineInRestoreCounts(payload: TREQUEST_RESTORE_COUNT_BUNDLE_LINE_IN) {
    const URL = this.bundleLineInEnvProvider.getEnvVar('FETCH_BUNDLE_LINE_IN_RESTORE_COUNTS');
    return this.http.post<TRESPONSE_RESTORE_COUNT_BUNDLE_LINE_IN>(URL, payload);
  }

  saveBundleLineInEvent(payload: TREQUEST_SAVE_EVENT_BUNDLE_LINE_IN) {
    const URL = this.bundleLineInEnvProvider.getEnvVar('SAVE_BUNDLE_LINE_IN_EVENT');
    return this.http.post<TRESPONSE_SAVE_EVENT_BUNDLE_LINE_IN>(URL, payload);
  }

  getBundleLineInTransactionLog(payload: TREQUEST_BUNDLE_LINE_IN_TRANSACTION_LOG) {
    const URL = this.bundleLineInEnvProvider.getEnvVar('GET_BUNDLE_LINE_IN_TRANSACTION_LOG');
    return this.http.post<TRESPONSE_BUNDLE_LINE_IN_TRANSACTION_LOG>(URL, payload);
  }

  getBundleLineInActivityLog(payload: TREQUEST_BUNDLE_LINE_IN_ACTIVITY_LOG) {
    const URL = this.bundleLineInEnvProvider.getEnvVar('GET_BUNDLE_LINE_IN_ACTIVITY_LOG');
    return this.http.post<TRESPONSE_BUNDLE_LINE_IN_ACTIVITY_LOG>(URL, payload);
  }

  getBundleLineInAvailableWip(payload: TREQUEST_BUNDLE_LINE_IN_AVAILABLE_WIP) {
    const URL = this.bundleLineInEnvProvider.getEnvVar('GET_BUNDLE_LINE_IN_AVAILABLE_WIP');
    return this.http.post<TRESPONSE_BUNDLE_LINE_IN_AVAILABLE_WIP>(URL, payload);
  }
}
